import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ResetPassword } from '../models/resetPassword';
import { User } from '../models/user';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  private headers = new HttpHeaders().set('Content-Type', 'application/json');
  private usersUrl = environment.organiserApiUrl + '/v1/users';
  private loginUrl: string = environment.organiserApiUrl + '/v1/auth';

  constructor(private http: HttpClient) {}

  getMe(): Observable<User> {
    return this.http.get<User>(this.usersUrl + '/me');
  }

  updateProfile(
    firstName?: string,
    lastName?: string,
    email?: string,
    birthDate?: string,
    address?: object
  ): Observable<User> {
    return this.http.put<User>(
      this.usersUrl + '/me',
      JSON.stringify({ firstName, lastName, email, birthDate, address }),
      { headers: this.headers }
    );
  }

  updateProfilePhone(phoneNumber: string): Observable<User> {
    return this.http.put<User>(
      this.usersUrl + '/me',
      JSON.stringify({ phoneNumber }),
      { headers: this.headers }
    );
  }
  resetPassword(password: ResetPassword, token: string): Observable<any> {
    return this.http.put(
      `${this.loginUrl}/reset_password/${token}`,
      JSON.stringify(password),
      { headers: this.headers }
    );
  }

  deleteUser(userId: any): Observable<any> {
    return this.http.delete<any>(`${this.usersUrl}/${userId}`);
  }

  updateUserPreferences(data: any): Observable<any> {
    return this.http.post(
      `${this.usersUrl}/me/preferences`,
      JSON.stringify(data),
      { headers: this.headers }
    );
  }

  getUserPreferences(): Observable<any> {
    return this.http.get(`${this.usersUrl}/me/preferences`, {
      headers: this.headers
    });
  }

}
